import KendoMenuMixin from './KendoMenuMixin'

export default {
    name: 'kendo-menu',
    mixins: [ KendoMenuMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoMenu/index.js